import React from 'react'
import Style from '../mappingUi.module.css'

const MappingCheckbox = ({ inputId, label, checked, isDisabled, onChange }) => (
    <div className={Style.checkbox}>
        <input
            id={inputId}
            type="checkbox"
            className={Style.checkboxInput}
            checked={checked}
            disabled={isDisabled}
            onChange={(event) => onChange(event.target.checked)}
        />
        <label className={Style.checkboxLabel} htmlFor={inputId} title={label}>{label}</label>
    </div>
)

export default MappingCheckbox
